import * as Yup from 'yup';
import {messages} from '../../../common/Models/Validations';

export const acquisitionInitialValue = {
  museum_id: null,
  acquisition_type_id: null,
  date_of_entry: '',
  dzongkhag_id: null,
  gewog_id: null,
  village_id: null,
  price: null,
  appraised_value: null,
  attachment_ids: [],
  translations: {
    en: {
      owner: '',
      chiwog: '',
      received_from: '',
      permanent_address: '',
      storage: '',
      location: ''
    }
  }
};


export const acquisitionValidation = Yup.object().shape({
  acquisition_type_id: Yup.mixed().required(messages?.required),
})